import {cx} from "@emotion/css";
import {ReactComponent as SvgAlert} from "assets/svg/alert.svg";

import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmAlertIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgAlert id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
